<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-6">
                    <card>
                        <h5 slot="header" class="card-title"><span @click="goBack()" class="link">Назад</span> -
                            Общая информация</h5>
                        <form>
                            <div class="row">
                                <div class="loader" v-if="waiting"></div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="premium-control"
                                               class="control-label label-checkbox">Премиум</label>
                                        <input v-model="track.is_premium" id="premium-control"
                                               class="form-check-inline"
                                               type="checkbox">
                                    </div>
                                    <div class="form-group">
                                        <label for="trendy-control"
                                               class="control-label label-checkbox">Популярное</label>
                                        <input v-model="track.is_trendy" id="trendy-control"
                                               class="form-check-inline"
                                               type="checkbox">
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Альбом</label>
                                        <select v-model="track.album_id"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option v-if="a.id !== 999" v-for="a in albums" v-bind:value="a.id">{{ a.name }}</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Статус</label>
                                        <select v-model="track.status"
                                                id="status-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option value="1">Активен</option>
                                            <option value="0">Не активен</option>
                                        </select>
                                    </div>
                                    <fg-input type="text"
                                              label="Артист"
                                              v-model="track.artist"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Название"
                                              v-model="track.title"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Длительность"
                                              v-model="track.duration"
                                              readonly
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Сортировка (чем больше, тем выше в списке)"
                                              v-model="track.sort"
                                              placeholder="">
                                    </fg-input>
                                </div>
                                <div class="col-md-6 buttons-block">
                                    <div>
                                        <h4 slot="header" class="card-title">
                                            Фон: <span v-if="track.image_src">
                                            <span class="inline-link">
                                                <span v-if="track.image_src_size >= 0.3"
                                                      class="bg-danger">{{ track.image_src_size }}Mb</span>
                                                <span v-else-if="track.image_src_size >= 0.2"
                                                      class="bg-warning">{{ track.image_src_size }}Mb</span>
                                                <span v-else>{{ track.image_src_size }}Mb</span>
                                                <a :href="track.image_src_full" target="_blank">(ссылка)</a></span>
                                        </span>
                                        </h4>

                                        <div>
                                            <input ref="imageFileInput" class="btn-file" type="file"
                                                   @change="uploadFile($event, 'image_src')">
                                            <button type="submit" class="btn btn-info btn-fill upload-button"
                                                    @click="$refs.imageFileInput.click()">
                                                Загрузить
                                            </button>
                                            <div class="clearfix"></div>
                                        </div>
                                    </div>
                                    <div class="margin-top">
                                        <h4 slot="header" class="card-title">
                                            Аудио: <span v-if="track.src">
                                            <span class="inline-link">
                                                <span v-if="track.src_size >= 4"
                                                      class="bg-danger">{{ track.src_size }}Mb</span>
                                                <span v-else-if="track.src_size >= 2"
                                                      class="bg-warning">{{ track.src_size }}Mb</span>
                                                <span v-else>{{ track.src_size }}Mb</span>
                                                <a :href="track.src_full" target="_blank">(ссылка)</a></span>
                                        </span>
                                        </h4>

                                        <div>
                                            <input ref="audioFileInput" class="btn-file" type="file"
                                                   accept="audio/mp3"
                                                   @change="uploadFile($event, 'src')">
                                            <button type="submit" class="btn btn-info btn-fill upload-button"
                                                    @click="$refs.audioFileInput.click()">
                                                Загрузить
                                            </button>
                                            <div class="clearfix"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="text-center">
                                <button type="submit" class="btn btn-success btn-fill float-right btn-save"
                                        :disabled="!track.album_id || !track.sort || !track.title || !track.artist || !track.src"
                                        @click.prevent="save">
                                    Сохранить
                                </button>
                            </div>
                            <div class="clearfix"></div>
                        </form>
                    </card>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import Card from 'src/components/UIComponents/Cards/Card.vue'

export default {
    name: 'CreateAlbum',
    components: {
        Card,
    },
    data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            track: {
                status: 0,
                src: null,
                src_full: null,
                image_src: null,
                image_src_full: null,
                sort: 1,
                artist: null,
                title: null,
                duration: null,
                album_id: null,
                is_premium: 1,
                is_trendy: 0
            },
            albums: [],
        }
    },
    created: function () {
        this.getAlbums();
    },
    methods: {
        goBack: function () {
            window.history.back();
        },
        getAlbums: function () {
            let self = this;

            axios.get(
                `${this.$hostname}/admin/albums`,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then(function (response) {

                    self.albums = JSON.parse(JSON.stringify(response.data));

                })
                .catch(function (error) {

                    const notification = {
                        template: `<span><b>${error.response.data.message}</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })
                });
        },
        save: function () {
            let self = this;

            let track = JSON.parse(JSON.stringify(this.track));

            self.waiting = true;

            axios.post(
                `${this.$hostname}/admin/tracks/create`,
                track,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then(function (response) {

                    const notification = {
                        template: `<span><b>Трек был успешно добавлен</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-explore-2',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'info'
                        })

                    self.waiting = false;

                    self.$router.push('/tracks');

                })
                .catch(function (error) {
                    const notification = {
                        template: `<span><b>${error.response.data.message}</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })

                    self.waiting = false;
                });
        },
        uploadFile: function (event, type) {
            let self = this;

            let formData = new FormData();

            self.waiting = true;

            let needID3 = type === 'src';

            formData.append('file', event.target.files[0]);

            axios.post(
                `${this.$hostname}/admin/services/file/upload`,
                formData,
                {
                    params: {
                        file_type: type,
                        needID3: needID3
                    },
                    headers: {
                        'Authorization': 'Bearer ' + this.token,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).then(function (response) {

                self.waiting = false;

                let data = JSON.parse(JSON.stringify(response.data));

                self.track[data.file_type] = data.url;
                self.track[data.file_type + '_full'] = data.url_full;
                self.track[data.file_type + '_size'] = data.filesize;

                if (needID3 && data.duration) {
                    data.duration = Math.floor(data.duration)

                    let minutes = (Math.floor(data.duration / 60)).toString();
                    let seconds = (data.duration % 60) < 10 ? '0' + (data.duration % 60).toString() : (data.duration % 60).toString();
                    self.track.duration = minutes + ':' + seconds;
                }

            })
                .catch(function (error) {
                    self.waiting = false;
                    console.log(error);
                });
        },
    }
}

</script>
<style scoped>
button:disabled,
button[disabled] {
    cursor: not-allowed;
}

.btn-save {
    width: 150px;
}

.buttons-block {
    padding-left: 20px !important;
}

.btn-info.btn-fill, .btn-info.btn-fill:active {
    color: #54abfe;
    background-color: #FFFFFF;
    border: 1px solid #54abfe;
    margin-top: 8px;
}

.checkbox-block {
    margin-top: 40px;
    margin-left: 40px;
}

.btn-file {
    display: none;
}
.label-checkbox {
    cursor: pointer;
}
.inline-link span {
    padding: 3px;
    border-radius: 4px;
    font-size: 18px;
}

.bg-danger {
    background-color: rgba(255, 70, 50, 0.5) !important;
}
.image-block {
    max-width: 100%;
}

.form-check-inline {
    display: inline-block;
}

.label-checkbox {
    margin-right: 10px
}

.link {
    cursor: pointer;
    text-decoration: underline;
}

.card-body p {
    font-weight: 300;
    font-style: italic;
}

.card-body form {
    /*margin-top: 15px;*/
}

/* Customize the label (the container) */
.container {
    display: block;
    position: relative;
    padding-left: 30px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 12px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

/* Create a custom checkbox */
.checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #ccc;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
    opacity: 0.8;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
    background-color: #54abfe;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
    display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
    left: 8px;
    top: 4px;
    width: 5px;
    height: 10px;
    border: solid #fff;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}

.preview-device {
    display: inline-block;
    width: 32%;
    margin-left: 10px;
}

.device-block {
    position: relative;
    background-position: center center;
    background-size: cover;
    cursor: pointer;
}

.device-block.inactive {
    opacity: 0.5;
}

.device-block span {
    position: absolute;
    top: -30px;
    left: 5px;
}

.device-block img {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 18px;
    top: 18px;
}

.device1 {
    display: inline-block;
    /*width: 281px;*/
    /*height: 609px;*/
    width: 337px;
    height: 731px;
    border: 3px solid #000;
    border-radius: 10px;
    margin-left: 40px;
}

.device2 {
    display: inline-block;
    /*width: 310px;*/
    /*height: 552px;*/
    width: 372px;
    height: 662px;
    border: 3px solid #000;
    border-radius: 10px;
    margin-left: 50px;
}

.device3 {
    display: inline-block;
    /*width: 384px;*/
    /*height: 640px;*/
    width: 461px;
    height: 614px;
    border: 3px solid #000;
    border-radius: 10px;
    margin-left: 50px;
}

.mt30 {
    margin-top: 30px;
}

#ajaxForm, ajaxForm2, ajaxForm3 {
    position: relative;
}

.loader {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url('/static/img/oval.svg');
    background-size: 50px;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10000000;
    opacity: 0.7;
    filter: alpha(opacity=40);
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Tracks/Create.vue